import jsPDF from 'jspdf';
/* eslint-disable */
// 1. CAMBIO AQUÍ: Importamos autoTable como una función directa
import autoTable from 'jspdf-autotable'; 
import logoBase64 from '@/assets/img/fondotam-blanco.png';

export const generarActaPDF = (datos) => {
  const doc = new jsPDF('p', 'pt', 'a4');
  const colorAzul = [0, 51, 102];
  
  // 1. ENCABEZADO Y LOGO
  doc.setFontSize(14);
  doc.setTextColor(colorAzul[0], colorAzul[1], colorAzul[2]);
  doc.setFont('helvetica', 'bold');
  doc.text("TRANSPORTE AÉREO MILITAR EMPRESA PÚBLICA", 40, 50);
  
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.setFont('helvetica', 'normal');
  doc.text("Sistema Integral para la Gestión Técnica de Activos Fijos", 40, 65);

  // 2. TÍTULO DEL ACTA
  doc.setFontSize(16);
  doc.setTextColor(0);
  doc.setFont('helvetica', 'bold');
  const titulo = datos.tipo === 'TR' ? "ACTA DE TRANSFERENCIA DE ACTIVO FIJO" : "ACTA DE DEVOLUCIÓN A ALMACÉN";
  doc.text(titulo, doc.internal.pageSize.width / 2, 100, { align: 'center' });
  
  doc.setFontSize(12);
  doc.setTextColor(200, 0, 0);
  doc.text(`Nro: ${datos.num_acta}`, doc.internal.pageSize.width / 2, 115, { align: 'center' });

  // 3. DATOS GENERALES
  doc.setTextColor(0);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text("FECHA DE EMISIÓN:", 40, 150);
  doc.setFont('helvetica', 'normal');
  doc.text(datos.fecha, 160, 150);

  doc.setFont('helvetica', 'bold');
  doc.text("MOTIVO / REF:", 40, 165);
  doc.setFont('helvetica', 'normal');
  const splitMotivo = doc.splitTextToSize(datos.motivo || 'Cambio de Custodio Legal', 350);
  doc.text(splitMotivo, 160, 165);

  // 2. CAMBIO AQUÍ: Usamos autoTable(doc, {...}) en lugar de doc.autoTable({...})
  // 4. TABLA: PERSONAL INVOLUCRADO
  autoTable(doc, {
    startY: 200,
    head: [['ROL', 'NOMBRE DEL FUNCIONARIO', 'CARGO / UNIDAD']],
    body: [
      ['ENTREGA (Emisor)', datos.emisor_nombre, datos.emisor_cargo],
      ['RECIBE (Receptor)', datos.receptor_nombre, datos.receptor_cargo]
    ],
    theme: 'grid',
    headStyles: { fillColor: colorAzul, textColor: [255, 255, 255], fontStyle: 'bold' },
    styles: { fontSize: 9, cellPadding: 6 },
    alternateRowStyles: { fillColor: [245, 245, 245] }
  });

  // 3. CAMBIO AQUÍ TAMBIÉN
  // 5. TABLA: DETALLE DEL BIEN
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 20,
    head: [['CÓDIGO', 'DESCRIPCIÓN DEL EQUIPO', 'NUEVA UBICACIÓN']],
    body: [
      [datos.activo_codigo, datos.activo_desc, datos.ubicacion_destino]
    ],
    theme: 'grid',
    headStyles: { fillColor: [100, 100, 100], textColor: [255, 255, 255] },
    styles: { fontSize: 9, cellPadding: 6 }
  });

  // 6. DECLARACIÓN LEGAL
  const textDeclaracion = "A través de la presente acta, el Funcionario Receptor asume la custodia legal y total responsabilidad por el buen uso, salvaguarda y conservación del activo fijo detallado anteriormente, en conformidad con la normativa interna vigente de TAMEP. El Funcionario que Entrega queda liberado de dicha responsabilidad a partir de la firma de este documento.";
  
  const splitDeclaracion = doc.splitTextToSize(textDeclaracion, doc.internal.pageSize.width - 80);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(9);
  doc.setTextColor(80);
  doc.text(splitDeclaracion, 40, doc.lastAutoTable.finalY + 30);

  // 7. FIRMAS
  const yFirmas = doc.internal.pageSize.height - 120;
  
  doc.setDrawColor(0);
  doc.setLineWidth(1);
  
  // Línea Firma Emisor
  doc.line(60, yFirmas, 240, yFirmas);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text("ENTREGUE CONFORME", 150, yFirmas + 15, { align: 'center' });
  doc.setFont('helvetica', 'normal');
  doc.text(datos.emisor_nombre, 150, yFirmas + 27, { align: 'center' });

  // Línea Firma Receptor
  doc.line(350, yFirmas, 530, yFirmas);
  doc.setFont('helvetica', 'bold');
  doc.text("RECIBÍ CONFORME", 440, yFirmas + 15, { align: 'center' });
  doc.setFont('helvetica', 'normal');
  doc.text(datos.receptor_nombre, 440, yFirmas + 27, { align: 'center' });

  // Generar y descargar el PDF
  doc.save(`ACTA_${datos.tipo}_${datos.num_acta}.pdf`);
};